import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./admin-shadcn.css";
import { BrowserRouter, Route, Switch, Redirect, useLocation } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import RtlLayout from "layouts/RTL.js";
import AdminLayout from "layouts/Admin.js";

import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";

import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";
import { SnackbarProvider } from "hooks/useSnackbar";
import { ConfirmationDialogProvider } from "hooks/useConfirmationDialog";
import { BASE_URL_API_ECOMMERCE } from "services/Http";
import { BASIC_AUTH } from "services/Http";
import { BackdropProvider } from "hooks/useBackdrop";
import { applyAdminUiSkin } from "./adminUiSkin";
import AdminThemeProvider from "components/AdminThemeProvider/AdminThemeProvider";

function AdminUiSkinSync() {
    const location = useLocation();

    React.useEffect(() => {
        applyAdminUiSkin();
    }, [location.pathname, location.search]);

    return null;
}

// Definir la función principal para gestionar la redirección y renderizado
function initializeApp() {
    applyAdminUiSkin();

    const gid = localStorage.getItem("_gid");

    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    // Mapeo de dominios a dlid
    const domainToDlidMap = {
        "friendlyisuzu.com": 52,
        "humberviewparts.ca": 53,
        "reynoldsisuzuparts.com": 48,
        "trucksmartisuzu.com": 54,
        "scarffisuzu.com": 55,
    };

    // Obtener el dominio base
    const baseDomain = hostname.split(".").slice(-2).join(".");
    const dlid = domainToDlidMap[baseDomain];

    // Si hay un dlid, se hace la redirección y no se renderiza la app
    if (dlid) {
        console.log("Redirigiendo antes de renderizar...");

        fetch(`${BASE_URL_API_ECOMMERCE}/dealer?dlid=${dlid}`, {
            headers: new Headers({
                Authorization: `Basic ${BASIC_AUTH}`,
            }),
        })
            .then((response) => response.json())
            .then((dealer) => {
                let dealerDomain = dealer.data.dealerDomain;
                let dealerAdminDomain = dealer.data.dealerAdminDomain;

                dealerDomain =
                    dealerDomain.startsWith("http://") || dealerDomain.startsWith("https://")
                        ? dealerDomain
                        : `https://${dealerDomain}`;

                dealerAdminDomain =
                    dealerAdminDomain.startsWith("http://") ||
                    dealerAdminDomain.startsWith("https://")
                        ? dealerAdminDomain
                        : `https://${dealerAdminDomain}`;

                if (pathname.includes("/admin")) {
                    window.location.href = dealerAdminDomain;
                } else {
                    window.location.href = dealerDomain;
                }
            })
            .catch((error) => console.error("Error al consultar la API:", error));

        return; // No continuar con el renderizado si se redirige
    }

    // Si no hay un dlid, renderizamos la aplicación normalmente
    renderApp();
}

// Función para renderizar la aplicación
function renderApp() {
    ReactDOM.render(
        <AdminThemeProvider>
            <SnackbarProvider>
                <ConfirmationDialogProvider>
                    <BackdropProvider>
                        <BrowserRouter>
                            <AdminUiSkinSync />
                            <Switch>
                                <Route path="/rtl" component={RtlLayout} />
                                <Route path="/auth" component={AuthLayout} />
                                <ProtectedRoute path="/admin" component={AdminLayout} />

                                {/* 🔁 Redirección desde / que conserva los query params */}
                                <Route
                                    exact
                                    path="/"
                                    render={({ location }) => (
                                        <Redirect to={`/admin/dashboard${location.search}`} />
                                    )}
                                />
                            </Switch>
                        </BrowserRouter>
                    </BackdropProvider>
                </ConfirmationDialogProvider>
            </SnackbarProvider>
        </AdminThemeProvider>,
        document.getElementById("root")
    );
}

// Inicializar la aplicación
initializeApp();
